import { render } from "./ConfiguracoesEmails.vue?vue&type=template&id=412cb7ca&ts=true"
import script from "./ConfiguracoesEmails.vue?vue&type=script&lang=ts"
export * from "./ConfiguracoesEmails.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\UniRH\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__